export const wikiURL = {
	home: "https://tested-theater-a99.notion.site/Live-Customer-Wiki-16590de096044db39330f203d1c25dde",
	crossWidgetComparison:
		"https://tested-theater-a99.notion.site/Compare-Widgets-In-Grouped-Charts-0b6380c2b57e4ab581ccbe28448560fa",
	faq: "https://tested-theater-a99.notion.site/Frequently-Asked-Questions-FAQ-363387e72f974c25b9fdee151d7a406b",
};
